export default __webpack_public_path__ + "static/media/icon_error_24_Regular_green.92b4a8a3.svg";